import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageMeta } from '@app/entities/images/interfaces/image-meta';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';

interface CarouselItem {
  name: string;
  logo: ImageMeta;
}

@Component({
  selector: 'app-they-use-image-base',
  templateUrl: './they-use-image-base.component.html',
  styleUrls: ['./they-use-image-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarouselModule],
})
export class TheyUseImageBaseComponent {
  protected owlOptions: OwlOptions = {
    margin: 30,
    nav: false,
    loop: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      900: {
        items: 3,
      },
      1200: {
        items: 4,
      },
      1500: {
        items: 5,
      },
      1800: {
        items: 6,
      },
    },
  };

  protected carouselItems: CarouselItem[] = [
    {
      name: 'Amazon',
      logo: {
        url: 'assets/logos/amazon.svg',
        width: 800,
        height: 240,
      },
    },
    {
      name: 'TM',
      logo: {
        url: 'assets/logos/tm.png',
        width: 2257,
        height: 1082,
      },
    },
    {
      name: 'Accenture',
      logo: {
        url: 'assets/logos/accenture.svg',
        width: 1024,
        height: 282,
      },
    },
    {
      name: 'Charfort',
      logo: {
        url: 'assets/logos/charfort.png',
        width: 919,
        height: 170,
      },
    },
    {
      name: 'Aldi',
      logo: {
        url: 'assets/logos/aldi.png',
        width: 1024,
        height: 340,
      },
    },
    {
      name: 'Alibuilding',
      logo: {
        url: 'assets/logos/alibuilding.png',
        width: 1105,
        height: 245,
      },
    },
  ];
}
